class ShamBundleStickyBar extends HTMLElement {
  connectedCallback() {
    this.count = this.querySelector('[data-product-count]');
    this.total = this.querySelector('[data-total-price]');
    this.cta = this.querySelector('[data-open-cart]');
    this.warning = this.querySelector('[data-warning-container]');
    if (!this.count || !this.total || !this.cta) return;

    this.ariaOne = this.dataset.ctaAriaOne || '';
    this.ariaOther = this.dataset.ctaAriaOther || '';

    this.onSync = this.sync.bind(this);
    this.onReserve = this.reserve.bind(this);
    this.onTransitionEnd = (e) => {
      if (e.target === this) this.reserve();
    };

    this.mutations = new MutationObserver(this.onSync);
    this.mutations.observe(this.count, { childList: true, characterData: true, subtree: true });
    this.mutations.observe(this.total, { childList: true, characterData: true, subtree: true });

    this.resizes = new ResizeObserver(this.onReserve);
    this.resizes.observe(this);

    window.addEventListener('resize', this.onReserve);
    window.addEventListener('orientationchange', this.onReserve);
    this.addEventListener('transitionend', this.onTransitionEnd);
    document.addEventListener('edit-mode:loaded', this.onSync);

    this.sync();
  }

  disconnectedCallback() {
    this.mutations?.disconnect();
    this.resizes?.disconnect();
    document.removeEventListener('edit-mode:loaded', this.onSync);
    window.removeEventListener('resize', this.onReserve);
    window.removeEventListener('orientationchange', this.onReserve);
    this.removeEventListener('transitionend', this.onTransitionEnd);
    document.body.style.paddingBottom = '';
  }

  sync() {
    const items = Number.parseInt((this.count.textContent || '').trim(), 10) || 0;

    const template = items === 1 ? this.ariaOne : this.ariaOther;
    if (template) {
      this.cta.setAttribute(
        'aria-label',
        template.replace('[count]', String(items)).replace('[total]', (this.total.textContent || '').trim())
      );
    }

    const showWarning = this.syncWarning();
    this.classList.toggle('is-visible', items > 0 || showWarning);
    this.reserve();
  }

  // Rule: editModeUpdateHold in bundle-page.js.
  syncWarning() {
    if (!this.warning) return false;
    const showWarning = window.editModeUpdateHold?.() === 'minimum';
    this.warning.classList.toggle('jc-hidden', !showWarning);
    return showWarning;
  }

  reserve() {
    if (!this.classList.contains('is-visible')) {
      document.body.style.paddingBottom = '';
      return;
    }
    const top = this.getBoundingClientRect().top;
    document.body.style.paddingBottom = `${Math.max(0, Math.ceil(window.innerHeight - top))}px`;
  }
}

customElements.define('sham-bundle-sticky-bar', ShamBundleStickyBar);
